import { DocumentConnection } from '../../common/model/document-connection-base';
import { CompanyDocumentType, CompanyDocumentTypeToString } from './const/documentEnums';

export class CompanyDocument extends DocumentConnection<CompanyDocumentType> {
  constructor() {
    super();
  }

  get connectionTypeText(): string {
    return CompanyDocumentTypeToString(this.connectionType);
  }

  company: string;

  toJSON() {
    var result = super.toJSON();
    result['company'] = this.company;
    return result;
  }
}
